import { render } from "./StatisticsThree.vue?vue&type=template&id=fb2e3d20&scoped=true&ts=true"
import script from "./StatisticsThree.vue?vue&type=script&lang=ts"
export * from "./StatisticsThree.vue?vue&type=script&lang=ts"

import "./StatisticsThree.vue?vue&type=style&index=0&id=fb2e3d20&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb2e3d20"]])

export default __exports__